import { render, staticRenderFns } from "./SsoButtons.vue?vue&type=template&id=cd918e8e&scoped=true"
import script from "./SsoButtons.vue?vue&type=script&lang=js"
export * from "./SsoButtons.vue?vue&type=script&lang=js"
import style0 from "./SsoButtons.vue?vue&type=style&index=0&id=cd918e8e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd918e8e",
  null
  
)

export default component.exports